import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from 'src/app/components/button/button.component';
import { LucideAngularModule } from 'lucide-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SensitiveDataContentService } from '../sensitive-data-content.service';
import { Label } from 'src/app/labels/englishLabels';
import { PermissionsService } from 'src/app/services/infra/permissionsService/permissions.service';
import { PermissionEnum } from 'src/app/models/auth0/permission.enum';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';

@Component({
  selector: 'app-fetch-all-content-bar',
  templateUrl: './fetch-all-content-bar.component.html',
  styleUrls: ['./fetch-all-content-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ButtonComponent,
    LucideAngularModule,
    MatTooltipModule,
    LabelsProviderPipe,
  ],
  standalone: true,
})
export class FetchAllContentBarComponent {
  integrationId = input.required<string>();
  threadId = input.required<string>();

  protected isSensitiveDataLoading =
    this._sensitiveDataContentService.isLoading;
  protected isSensitiveDataError =
    this._sensitiveDataContentService.isErrorDuringFetch;
  protected allSensitiveDataLoaded =
    this._sensitiveDataContentService.allSensitiveDataLoaded;

  protected description = computed(() => {
    const error = this.isSensitiveDataError();
    if (error) {
      const status = error.status;
      if (status === 403) {
        return Label.get(
          'enterpriseAIThreads.fetchContentForbidden'
        );
      }
      if (status === 404) {
        return Label.get(
          'enterpriseAIThreads.fetchContentNotFound'
        );
      }
      if (status === 422) {
        if (error.error?.detail) {
          this._logger.warn(
            `Fetch content 422: ${error.error.detail}`
          );
        }
        return Label.get(
          'enterpriseAIThreads.fetchContentUnprocessable'
        );
      }
      if (status === 429) {
        return Label.get(
          'enterpriseAIThreads.fetchContentRateLimited'
        );
      }
      return Label.get('enterpriseAIThreads.fetchContentError');
    }
    return Label.get(
      'enterpriseAIThreads.fetchContentDescription'
    );
  });

  protected Label = Label;
  protected PermissionEnum = PermissionEnum;

  constructor(
    private readonly _sensitiveDataContentService: SensitiveDataContentService,
    protected readonly _permissionsService: PermissionsService,
    private readonly _logger: LoggerService
  ) {}

  public fetchContent(event: MouseEvent): void {
    event.stopPropagation();
    this._sensitiveDataContentService.fetchContent(
      this.integrationId(),
      this.threadId()
    );
  }
}
